import { NeDescIcon } from '@eastcoal/icon/NeDescIcon'

import { MenuButton } from '../../../MenuButton'
import { useImageCardStore } from '../../Store/hooks/useStore'

export const DescButton = () => {
  const toggleDescInputVisible = useImageCardStore(
    state => state.toggleDescInputVisible
  )

  return (
    <MenuButton icon={<NeDescIcon />} onClick={() => toggleDescInputVisible()}>
      描述
    </MenuButton>
  )
}
